/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Tab_PracticeInputs */

const en_interview_tab_practice = /** @type {(inputs: Interview_Tab_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Practice`)
};

const de_interview_tab_practice = /** @type {(inputs: Interview_Tab_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übung`)
};

const fr_interview_tab_practice = /** @type {(inputs: Interview_Tab_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercice`)
};

const es_interview_tab_practice = /** @type {(inputs: Interview_Tab_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Práctica`)
};

const it_interview_tab_practice = /** @type {(inputs: Interview_Tab_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esercitazione`)
};

const nl_interview_tab_practice = /** @type {(inputs: Interview_Tab_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oefenen`)
};

const pl_interview_tab_practice = /** @type {(inputs: Interview_Tab_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ćwiczenie`)
};

const fi_interview_tab_practice = /** @type {(inputs: Interview_Tab_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harjoittelu`)
};

const da_interview_tab_practice = /** @type {(inputs: Interview_Tab_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Øvelse`)
};

const sv_interview_tab_practice = /** @type {(inputs: Interview_Tab_PracticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Övning`)
};

/**
* | output |
* | --- |
* | "Practice" |
*
* @param {Interview_Tab_PracticeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_tab_practice = /** @type {((inputs?: Interview_Tab_PracticeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Tab_PracticeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_tab_practice(inputs)
	if (locale === "fr") return fr_interview_tab_practice(inputs)
	if (locale === "es") return es_interview_tab_practice(inputs)
	if (locale === "it") return it_interview_tab_practice(inputs)
	if (locale === "nl") return nl_interview_tab_practice(inputs)
	if (locale === "pl") return pl_interview_tab_practice(inputs)
	if (locale === "fi") return fi_interview_tab_practice(inputs)
	if (locale === "da") return da_interview_tab_practice(inputs)
	if (locale === "sv") return sv_interview_tab_practice(inputs)
	return en_interview_tab_practice(inputs)
});